import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { LookupResponse } from '../../responses/integration-siga/lookup-siga.response';

@Injectable({
  providedIn: 'root'
})
export class LookupSigaService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  
  public listLookup(): Observable<LookupResponse> {

    let uri = `Lookup`
    
    return this.httpClient.get<LookupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiIntegrationSiga) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

}
